import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const Graph24 = (props: SvgIconProps): JSX.Element => React.createElement(SvgIcon, props, <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path fillRule='evenodd' clipRule='evenodd' d='M12 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm6 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1ZM7 14a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6Z' /></svg>);
